import { getConfig } from '../config/getConfig';

export const isDemoMode = () => getConfig().DEMO === true;

export const isDemoCompany = (companyId) => isDemoMode() && !!companyId;

function seededRandom(seed) {
    let s = seed;
    return () => { s = (s * 16807 + 0) % 2147483647; return (s - 1) / 2147483646; };
}
function hashStr(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    return Math.abs(h);
}

const companyNames = {
    cf: ['Lumenoid Ventures', 'Nexara Solutions', 'Apexion Group', 'Solvanta Tech', 'Veltrex Innovations'],
    api: ['Nexara Solutions', 'Quantara Labs', 'Veltrex Innovations', 'Glyphonix Industries', 'Starlit Synergy'],
    sdk: ['Orbitella Systems', 'Quantara Labs', 'BluePeak Dynamics', 'Solvanta Tech', 'Apexion Group']
};
const getNames = (type) => companyNames[type] || companyNames.cf;

function generateDates(days) {
    const dates = [];
    const now = new Date();
    for (let i = days - 1; i >= 0; i--) {
        const d = new Date(now); d.setDate(d.getDate() - i);
        dates.push(d.toISOString().split('T')[0]);
    }
    return dates;
}

function generateHourlyTimeSeries(days) {
    const data = [];
    const now = new Date();
    for (let d = days - 1; d >= 0; d--) {
        for (let h = 0; h < 24; h++) {
            const date = new Date(now); date.setDate(date.getDate() - d); date.setHours(h, 0, 0, 0);
            data.push(date.toISOString().replace('Z', ''));
        }
    }
    return data;
}

const hourRanges = ['0-2', '2-4', '4-6', '6-8', '8-10', '10-12', '12-14', '14-16', '16-18', '18-20', '20-22', '22-24'];

// ===== 총괄대시보드 =====

export const mockAllReqSummary = (period) => {
    const presets = {
        now: { cf: 30200, api: 22400, sdk: 9900 },
        week: { cf: 198500, api: 147200, sdk: 65100 },
        month: { cf: 812000, api: 602000, sdk: 266000 },
        day: { cf: 30200, api: 22400, sdk: 9900 }
    };
    const p = presets[period] || presets.now;
    const total = p.cf + p.api + p.sdk;
    return {
        data: {
            totalRequestCnt: total,
            totalAPIRequestCnt: p.api,
            totalCFRequestCnt: p.cf,
            totalSDKRequestCnt: p.sdk,
            apirequestPer: +((p.api / total) * 100).toFixed(1),
            cfrequestPer: +((p.cf / total) * 100).toFixed(1),
            sdkrequestPer: +((p.sdk / total) * 100).toFixed(1),
            avgAPICalDuration: period === 'month' ? 0.019 : period === 'week' ? 0.021 : 0.024,
            avgCFCalDuration: period === 'month' ? 0.014 : period === 'week' ? 0.016 : 0.018,
            avgSDKCalDuration: period === 'month' ? 0.025 : period === 'week' ? 0.029 : 0.033,
            failAPIRequestPer: period === 'month' ? 0.07 : period === 'week' ? 0.09 : 0.12,
            failCFRequestPer: period === 'month' ? 0.03 : period === 'week' ? 0.05 : 0.07,
            failSDKRequestPer: period === 'month' ? 0.08 : period === 'week' ? 0.11 : 0.15,
            totalCompanyCnt: 10
        }
    };
};

export const mockAnomaliesRank = (period, type) => {
    const names = getNames(type);
    const failData = {
        cf: { sizes: [3340, 2100, 980], pers: [1.1, 0.7, 0.3] },
        api: { sizes: [4520, 2850, 1240], pers: [1.4, 0.9, 0.4] },
        sdk: { sizes: [2180, 1350, 620], pers: [1.8, 1.1, 0.5] }
    };
    const fd = failData[type] || failData.cf;
    const unusedData = {
        cf: [4, 3, 2],
        api: [5, 4, 2],
        sdk: [7, 5, 3]
    };
    const ud = unusedData[type] || unusedData.cf;
    return {
        data: {
            top1FailCompany: names[0], top1FailPer: fd.pers[0], top1FailDataSize: fd.sizes[0],
            top2FailCompany: names[1], top2FailPer: fd.pers[1], top2FailDataSize: fd.sizes[1],
            top3FailCompany: names[2], top3FailPer: fd.pers[2], top3FailDataSize: fd.sizes[2],
            top1NotUsePoliComp: names[3], top1NotUseCnt: ud[0],
            top2NotUsePoliComp: names[4], top2NotUseCnt: ud[1],
            top3NotUsePoliComp: names[0], top3NotUseCnt: ud[2]
        }
    };
};

export const mockActiveRank = (period, type) => {
    const names = getNames(type);
    const reqData = {
        cf: [18200, 15400, 11800],
        api: [14200, 12900, 9950],
        sdk: [8400, 7100, 5200]
    };
    const procData = {
        cf: [352.18, 298.45, 228.60],
        api: [277.34, 254.88, 193.16],
        sdk: [164.20, 138.75, 101.30]
    };
    const spdData = {
        cf: [0.008, 0.012, 0.015],
        api: [0.012, 0.018, 0.022],
        sdk: [0.021, 0.028, 0.035]
    };
    const spdSizes = {
        cf: [8.01, 13.77, 6.45],
        api: [6.45, 13.77, 8.01],
        sdk: [4.82, 9.15, 5.63]
    };
    const rd = reqData[type] || reqData.cf;
    const pd = procData[type] || procData.cf;
    const sd = spdData[type] || spdData.cf;
    const ss = spdSizes[type] || spdSizes.cf;
    return {
        data: {
            top1ReqCompany: names[0], top1RequestSize: rd[0],
            top2ReqCompany: names[1], top2RequestSize: rd[1],
            top3ReqCompany: names[2], top3RequestSize: rd[2],
            top1ProcCompany: names[1], top1ProcSize: pd[0],
            top2ProcCompany: names[2], top2ProcSize: pd[1],
            top3ProcCompany: names[0], top3ProcSize: pd[2],
            top1SpeedCompany: names[3], top1Speed: sd[0], top1SpeedSize: ss[0],
            top2SpeedCompany: names[4], top2Speed: sd[1], top2SpeedSize: ss[1],
            top3SpeedCompany: names[0], top3Speed: sd[2], top3SpeedSize: ss[2]
        }
    };
};

export const mockAvgRequest = (type, period) => {
    const names = getNames(type);
    const base = {
        cf: { now: [4200, 3500, 2800, 2100, 1500], week: [5800, 4900, 3900, 3100, 2200], month: [7200, 6100, 4800, 3800, 2700] },
        api: { now: [3100, 2600, 2100, 1600, 1100], week: [4300, 3600, 2900, 2200, 1500], month: [5400, 4500, 3600, 2800, 1900] },
        sdk: { now: [1800, 1500, 1200, 900, 600], week: [2500, 2100, 1700, 1300, 880], month: [3200, 2700, 2100, 1600, 1100] }
    };
    const vals = (base[type] || base.cf)[period] || (base[type] || base.cf).now;
    return {
        data: {
            top1_company: names[0], top1_avg_req: vals[0], top1_min_req: Math.round(vals[0] * 0.5), top1_max_req: Math.round(vals[0] * 1.6),
            top2_company: names[1], top2_avg_req: vals[1], top2_min_req: Math.round(vals[1] * 0.5), top2_max_req: Math.round(vals[1] * 1.6),
            top3_company: names[2], top3_avg_req: vals[2], top3_min_req: Math.round(vals[2] * 0.5), top3_max_req: Math.round(vals[2] * 1.6),
            top4_company: names[3], top4_avg_req: vals[3], top4_min_req: Math.round(vals[3] * 0.5), top4_max_req: Math.round(vals[3] * 1.6),
            top5_company: names[4], top5_avg_req: vals[4], top5_min_req: Math.round(vals[4] * 0.5), top5_max_req: Math.round(vals[4] * 1.6)
        }
    };
};

export const mockTimeDistribution = (type, period) => {
    const names = getNames(type);
    const days = period === 'week' ? 7 : period === 'month' ? 28 : 1;
    const dates = generateDates(days);
    const sizeBase = type === 'api' ? 18 : type === 'sdk' ? 10 : 28;

    const companies = names.slice(0, 3).map((name, ci) => {
        const rng = seededRandom(hashStr(name + type + period));
        return {
            companyName: name,
            topTwoHourlyData: dates.map((date) => ({
                date,
                hourlyData: hourRanges.map((hr) => {
                    const hourIdx = parseInt(hr);
                    const isBusinessHour = hourIdx >= 8 && hourIdx <= 18;
                    const peak = isBusinessHour ? 1.4 : 0.4;
                    const companyScale = 1 - ci * 0.2;
                    return { hourRange: hr, processedDataSize: Math.round(sizeBase * (0.5 + rng() * 0.8) * peak * companyScale) };
                })
            }))
        };
    });
    return { data: companies };
};

export const mockHourlyAvg = (type, period) => {
    const names = getNames(type);
    const baseMs = type === 'api' ? 0.018 : type === 'sdk' ? 0.028 : 0.012;
    const m = period === 'month' ? 0.92 : period === 'week' ? 0.96 : 1.0;

    const companies = names.slice(0, 5).map((name, idx) => {
        const rng = seededRandom(hashStr(name + type + period));
        return {
            companyName: name,
            hourlyAvgDataList: Array.from({ length: 24 }, (_, hour) => {
                const isBusinessHour = hour >= 8 && hour <= 18;
                const load = isBusinessHour ? 1.15 : 0.85;
                return {
                    hour,
                    hourlyAvgDuration: +((baseMs + idx * 0.003) * load * m * (0.9 + rng() * 0.2)).toFixed(4)
                };
            })
        };
    });
    return { data: companies };
};

export const mockPolicyPerRank = (period) => {
    const offset = period === 'month' ? 3 : period === 'week' ? 1 : 0;
    return {
        data: [
            { companyName: 'Lumenoid Ventures', unUsedPer: 24.5 - offset, usedPer: 75.5 + offset, unUsedCnt: 8, usedCnt: 25 },
            { companyName: 'Nexara Solutions', unUsedPer: 19.2 - offset, usedPer: 80.8 + offset, unUsedCnt: 6, usedCnt: 25 },
            { companyName: 'Apexion Group', unUsedPer: 15.8 - offset, usedPer: 84.2 + offset, unUsedCnt: 5, usedCnt: 27 },
            { companyName: 'Solvanta Tech', unUsedPer: 11.3 - offset, usedPer: 88.7 + offset, unUsedCnt: 3, usedCnt: 24 },
            { companyName: 'Veltrex Innovations', unUsedPer: 7.6 - offset, usedPer: 92.4 + offset, unUsedCnt: 2, usedCnt: 24 }
        ]
    };
};

export const mockPolicyPeriodRank = (period) => {
    const m = period === 'month' ? 2.5 : period === 'week' ? 1.5 : 1;
    return {
        data: [
            { companyName: 'Lumenoid Ventures', unUsedPer: 24.5, unUsedPeriod: Math.round(18 * m) },
            { companyName: 'Nexara Solutions', unUsedPer: 19.2, unUsedPeriod: Math.round(14 * m) },
            { companyName: 'Apexion Group', unUsedPer: 15.8, unUsedPeriod: Math.round(10 * m) },
            { companyName: 'Solvanta Tech', unUsedPer: 11.3, unUsedPeriod: Math.round(7 * m) },
            { companyName: 'Veltrex Innovations', unUsedPer: 7.6, unUsedPeriod: Math.round(4 * m) }
        ]
    };
};

export const mockTotalAlgoRequest = (period) => {
    const m = period === 'month' ? 12 : period === 'week' ? 4 : 1;
    const aes = Math.round(5820 * m), aria = Math.round(4350 * m), seed = Math.round(2640 * m), rsa = Math.round(920 * m), sha = Math.round(470 * m);
    const total = aes + aria + seed + rsa + sha;
    return {
        data: {
            algoInfoList: [
                { algoName: 'AES', requestCnt: aes, requestPer: +((aes / total) * 100).toFixed(1) },
                { algoName: 'ARIA', requestCnt: aria, requestPer: +((aria / total) * 100).toFixed(1) },
                { algoName: 'SEED', requestCnt: seed, requestPer: +((seed / total) * 100).toFixed(1) },
                { algoName: 'RSA', requestCnt: rsa, requestPer: +((rsa / total) * 100).toFixed(1) },
                { algoName: 'SHA', requestCnt: sha, requestPer: +((sha / total) * 100).toFixed(1) }
            ]
        }
    };
};

// ===== 고객사별 대시보드 =====

export const mockSummaryCounts = (period, type = 'cf') => {
    const typeScale = { cf: 1.0, api: 0.7, sdk: 0.35 };
    const scale = typeScale[type] || 1.0;
    const vals = {
        now: { encS: Math.round(320 * scale), encF: Math.max(1, Math.round(1 * scale)), decS: Math.round(275 * scale), decF: Math.max(1, Math.round(1 * scale)) },
        week: { encS: Math.round(2180 * scale), encF: Math.max(1, Math.round(5 * scale)), decS: Math.round(1860 * scale), decF: Math.max(1, Math.round(4 * scale)) },
        month: { encS: Math.round(8950 * scale), encF: Math.max(1, Math.round(18 * scale)), decS: Math.round(7620 * scale), decF: Math.max(1, Math.round(14 * scale)) },
        day: { encS: Math.round(320 * scale), encF: Math.max(1, Math.round(1 * scale)), decS: Math.round(275 * scale), decF: Math.max(1, Math.round(1 * scale)) }
    };
    const v = vals[period] || vals.now;
    return {
        data: [{
            total_cnt: v.encS + v.encF + v.decS + v.decF,
            encrypt_success_cnt: v.encS,
            encrypt_fail_cnt: v.encF,
            decrypt_success_cnt: v.decS,
            decrypt_fail_cnt: v.decF
        }]
    };
};

export const mockDataSize = (period, type = 'cf') => {
    const now = new Date();
    const typeScale = { cf: 1.0, api: 0.65, sdk: 0.3 };
    const scale = typeScale[type] || 1.0;
    const rng = seededRandom(hashStr('dataSize' + period + type));

    if (period === 'now') {
        return {
            data: Array.from({ length: 60 }, (_, i) => {
                const d = new Date(now.getTime() - (59 - i) * 60000);
                return {
                    periodKst: d.toISOString().replace('Z', ''),
                    size: Math.round(2800 * scale * (0.7 + rng() * 0.6)),
                    failSize: rng() > 0.92 ? Math.round(3 + rng() * 10) : 0
                };
            })
        };
    }

    const days = period === 'week' ? 7 : 28;
    const sizeBase = (period === 'week' ? 150000 : 120000) * scale;
    return {
        data: Array.from({ length: days }, (_, i) => {
            const d = new Date(now); d.setDate(d.getDate() - (days - 1 - i));
            return {
                periodKst: d.toISOString().split('T')[0] + 'T00:00:00',
                size: Math.round(sizeBase * (0.7 + rng() * 0.6)),
                failSize: rng() > 0.88 ? Math.round(8 + rng() * 25) : 0
            };
        })
    };
};

export const mockRecentlyEncDec = (period, type = 'cf') => {
    const now = new Date();
    const typeScale = { cf: 1.0, api: 0.6, sdk: 0.25 };
    const scale = typeScale[type] || 1.0;
    const rng = seededRandom(hashStr('encDec' + period + type));

    if (period === 'now') {
        return {
            data: Array.from({ length: 60 }, (_, i) => {
                const d = new Date(now.getTime() - (59 - i) * 60000);
                return {
                    periodKst: d.toISOString().replace('Z', ''),
                    encrypt_cnt: Math.round(85 * scale * (0.6 + rng() * 0.8)),
                    decrypt_cnt: Math.round(72 * scale * (0.6 + rng() * 0.8))
                };
            })
        };
    }

    const days = period === 'week' ? 7 : 28;
    const encBase = (period === 'week' ? 4500 : 3500) * scale;
    const decBase = (period === 'week' ? 3800 : 2900) * scale;
    return {
        data: Array.from({ length: days }, (_, i) => {
            const d = new Date(now); d.setDate(d.getDate() - (days - 1 - i));
            return {
                periodKst: d.toISOString().split('T')[0] + 'T00:00:00',
                encrypt_cnt: Math.round(encBase * (0.7 + rng() * 0.6)),
                decrypt_cnt: Math.round(decBase * (0.7 + rng() * 0.6))
            };
        })
    };
};

export const mockKeyTypeComp = () => ({
    data: [{ total_cnt: 597, api_cnt: 232, cf_cnt: 278, sdk_cnt: 87 }]
});

export const mockAlgoComp = (type = 'cf') => {
    const typeData = {
        cf: [
            { algoName: 'AES', requestCnt: 258, requestPer: 43.2 },
            { algoName: 'ARIA', requestCnt: 182, requestPer: 30.5 },
            { algoName: 'SEED', requestCnt: 104, requestPer: 17.4 },
            { algoName: 'RSA', requestCnt: 53, requestPer: 8.9 }
        ],
        api: [
            { algoName: 'AES', requestCnt: 185, requestPer: 46.8 },
            { algoName: 'ARIA', requestCnt: 112, requestPer: 28.3 },
            { algoName: 'SEED', requestCnt: 65, requestPer: 16.4 },
            { algoName: 'RSA', requestCnt: 34, requestPer: 8.5 }
        ],
        sdk: [
            { algoName: 'AES', requestCnt: 92, requestPer: 48.4 },
            { algoName: 'ARIA', requestCnt: 55, requestPer: 28.9 },
            { algoName: 'SEED', requestCnt: 30, requestPer: 15.8 },
            { algoName: 'RSA', requestCnt: 13, requestPer: 6.9 }
        ]
    };
    const list = typeData[type] || typeData.cf;
    const totalCnt = list.reduce((sum, item) => sum + item.requestCnt, 0);
    return {
        data: {
            algoInfoList: list,
            totalCnt
        }
    };
};

export const mockEncKeyComp = (type = 'cf', order = 'DESC') => {
    const topData = {
        cf: {
            top1: 'user_enc_key', top1_total_cnt: 142, top1_encrypt: 88, top1_decrypt: 54,
            top2: 'card_token', top2_total_cnt: 118, top2_encrypt: 70, top2_decrypt: 48,
            top3: 'ssn_mask', top3_total_cnt: 95, top3_encrypt: 56, top3_decrypt: 39,
            top4: 'email_enc', top4_total_cnt: 72, top4_encrypt: 43, top4_decrypt: 29,
            top5: 'phone_hash', top5_total_cnt: 48, top5_encrypt: 28, top5_decrypt: 20
        },
        api: {
            top1: 'api_session_key', top1_total_cnt: 98, top1_encrypt: 62, top1_decrypt: 36,
            top2: 'rest_enc_key', top2_total_cnt: 82, top2_encrypt: 50, top2_decrypt: 32,
            top3: 'token_key', top3_total_cnt: 67, top3_encrypt: 40, top3_decrypt: 27,
            top4: 'batch_enc', top4_total_cnt: 51, top4_encrypt: 30, top4_decrypt: 21,
            top5: 'webhook_hash', top5_total_cnt: 35, top5_encrypt: 20, top5_decrypt: 15
        },
        sdk: {
            top1: 'mobile_enc_key', top1_total_cnt: 55, top1_encrypt: 35, top1_decrypt: 20,
            top2: 'app_token', top2_total_cnt: 42, top2_encrypt: 26, top2_decrypt: 16,
            top3: 'local_enc', top3_total_cnt: 33, top3_encrypt: 20, top3_decrypt: 13,
            top4: 'file_enc', top4_total_cnt: 25, top4_encrypt: 15, top4_decrypt: 10,
            top5: 'db_hash', top5_total_cnt: 18, top5_encrypt: 10, top5_decrypt: 8
        }
    };
    const bottomData = {
        cf: {
            top1: 'legacy_backup', top1_total_cnt: 5, top1_encrypt: 3, top1_decrypt: 2,
            top2: 'test_key_v1', top2_total_cnt: 8, top2_encrypt: 5, top2_decrypt: 3,
            top3: 'archive_enc', top3_total_cnt: 12, top3_encrypt: 7, top3_decrypt: 5,
            top4: 'temp_token', top4_total_cnt: 15, top4_encrypt: 9, top4_decrypt: 6,
            top5: 'log_hash', top5_total_cnt: 19, top5_encrypt: 11, top5_decrypt: 8
        },
        api: {
            top1: 'debug_key', top1_total_cnt: 3, top1_encrypt: 2, top1_decrypt: 1,
            top2: 'test_api_key', top2_total_cnt: 6, top2_encrypt: 4, top2_decrypt: 2,
            top3: 'staging_enc', top3_total_cnt: 10, top3_encrypt: 6, top3_decrypt: 4,
            top4: 'old_session', top4_total_cnt: 14, top4_encrypt: 8, top4_decrypt: 6,
            top5: 'fallback_key', top5_total_cnt: 18, top5_encrypt: 10, top5_decrypt: 8
        },
        sdk: {
            top1: 'dev_test_key', top1_total_cnt: 2, top1_encrypt: 1, top1_decrypt: 1,
            top2: 'beta_enc', top2_total_cnt: 4, top2_encrypt: 2, top2_decrypt: 2,
            top3: 'cache_key', top3_total_cnt: 7, top3_encrypt: 4, top3_decrypt: 3,
            top4: 'temp_sdk', top4_total_cnt: 10, top4_encrypt: 6, top4_decrypt: 4,
            top5: 'old_mobile', top5_total_cnt: 13, top5_encrypt: 7, top5_decrypt: 6
        }
    };
    const source = order === 'ASC' ? bottomData : topData;
    return { data: [source[type] || source.cf] };
};

export const mockSixMonthPay = () => {
    const now = new Date();
    const months = [];
    for (let i = 5; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        months.push(`${d.getFullYear()}.${d.getMonth() + 1}`);
    }
    const fees = [128500, 142300, 135800, 151200, 146700, 139400];
    return { data: months.map((ym, i) => ({ year_month: ym, total_fee: fees[i] })) };
};

export const mockCompanyList = () => {
    const companies = [
        { name: 'BluePeak Dynamics', companyId: 'b2b6f6dc', email: 'admin@bluepeak.com', tel: '02-1234-5678' },
        { name: 'Nexara Solutions', companyId: '0bb51711', email: 'info@nexara.io', tel: '02-2345-6789' },
        { name: 'Quantara Labs', companyId: '99b2d533', email: 'support@quantara.com', tel: '02-3456-7890' },
        { name: 'Veltrex Innovations', companyId: 'cf10121e', email: 'sec@veltrex.co.kr', tel: '02-4567-8901' },
        { name: 'Solvanta Tech', companyId: 'd50f0dfe', email: 'hello@solvanta.tech', tel: '02-5678-9012' }
    ];
    return {
        data: {
            content: companies.map((c) => ({
                insertTimeUtc: '2025-01-15T09:00:00', updateTimeUtc: '2025-03-01T14:30:00',
                imgUrl: '', active: true, description: `${c.name} - SafeDB 고객사`,
                name: c.name, email: c.email, tel: c.tel, address: '서울특별시 강남구',
                companyId: c.companyId, pricingPolicyUuid: 'default-policy', pricingPolicyName: '기본 요금제'
            })),
            page: { totalElements: 5 }
        }
    };
};

export const mockCompanyInfo = () => ({
    data: {
        insertTimeUtc: '2025-01-15T09:00:00', updateTimeUtc: '2025-03-01T14:30:00',
        name: 'Demo Company', email: 'demo@safedb.biz', tel: '02-1234-5678',
        address: '서울특별시 강남구', description: 'Demo Company',
        secret: '', key: '', iv: '', imgUrl: '',
        pricingPolicyUuid: 'default-policy', pricingPolicyName: '기본 요금제'
    }
});

// ===== 공유키 데모 데이터 =====
export const mockPubKeyList = (page = 0, size = 10) => {
    const sharedKeys = [
        { name: 'master_enc_key', algo: 'AES', keyLen: 256, mode: 'CBC', desc: '마스터 암호화 키', dayOffset: -45 },
        { name: 'card_token_key', algo: 'AES', keyLen: 256, mode: 'GCM', desc: '카드 토큰 암호화 키', dayOffset: -30 },
        { name: 'ssn_mask_key', algo: 'ARIA', keyLen: 128, mode: 'CBC', desc: '주민번호 마스킹 키', dayOffset: -25 },
        { name: 'email_enc_key', algo: 'AES', keyLen: 128, mode: 'CBC', desc: '이메일 암호화 키', dayOffset: -20 },
        { name: 'phone_hash_key', algo: 'SHA', keyLen: 256, mode: 'NONE', desc: '전화번호 해시 키', dayOffset: -15 },
        { name: 'api_session_key', algo: 'AES', keyLen: 256, mode: 'GCM', desc: 'API 세션 키', dayOffset: -12 },
        { name: 'backup_enc_key', algo: 'ARIA', keyLen: 256, mode: 'CBC', desc: '백업 암호화 키', dayOffset: -10 },
        { name: 'log_integrity_key', algo: 'SHA', keyLen: 512, mode: 'NONE', desc: '로그 무결성 검증 키', dayOffset: -7 },
    ];

    const now = new Date();
    const totalElements = sharedKeys.length;
    const startIdx = page * size;
    const endIdx = Math.min(startIdx + size, totalElements);
    const pageContent = sharedKeys.slice(startIdx, endIdx);

    return {
        data: {
            content: pageContent.map((k) => {
                const insertDate = new Date(now);
                insertDate.setDate(insertDate.getDate() + k.dayOffset);
                return {
                    sharedkeyName: k.name,
                    algo: k.algo,
                    keyLen: k.keyLen,
                    mode: k.mode,
                    description: k.desc,
                    sharedkeyId: { sharedkeyUuid: `demo-sk-${k.name}` },
                    insertTimeUtc: insertDate.toISOString()
                };
            }),
            page: { totalElements, totalPages: Math.ceil(totalElements / size), number: page, size }
        }
    };
};

// ===== 관리로그 데모 데이터 =====
export const mockManageLog = (page = 0, size = 10) => {
    const now = new Date();
    const rng = seededRandom(hashStr('manageLog' + now.toISOString().split('T')[0]));

    const users = [
        { id: 'admin', role: 'ADMIN' },
        { id: 'manager01', role: 'MANAGER' },
        { id: 'manager02', role: 'MANAGER' },
        { id: 'admin02', role: 'ADMIN' },
    ];

    const tasks = [
        '로그인', '암호키 등록', '암호키 삭제', '암호키 변경',
        '공유키 등록', '공유키 변경', '인증키 등록', '인증키 변경',
        '인증키 삭제', '그룹 등록', '그룹 변경', '사용자 등록',
        '비밀번호 변경', '정책 변경', '에이전트 배포', '로그아웃',
        '인증키 재발급', 'SDK 다운로드', '정책 조회', '대시보드 조회'
    ];

    const totalElements = 156;
    const allLogs = [];

    for (let i = 0; i < totalElements; i++) {
        const minutesAgo = Math.floor(rng() * 60 * 24 * 7); // 최근 7일
        const logDate = new Date(now.getTime() - minutesAgo * 60000);
        const user = users[Math.floor(rng() * users.length)];
        const task = tasks[Math.floor(rng() * tasks.length)];
        const resultVal = rng() > 0.05 ? 0 : (rng() > 0.5 ? 1 : 2); // 95% 성공

        allLogs.push({
            insertTime: logDate.toISOString().replace('Z', ''),
            userRole: user.role,
            userId: user.id,
            taskHistory: task,
            result: resultVal,
            requestDetails: JSON.stringify({
                method: task.includes('조회') ? 'GET' : (task.includes('등록') ? 'POST' : (task.includes('삭제') ? 'DELETE' : 'PUT')),
                path: `/api/${task.replace(/\s/g, '')}`,
                ip: `192.168.1.${Math.floor(rng() * 254) + 1}`,
                userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)'
            })
        });
    }

    allLogs.sort((a, b) => new Date(b.insertTime) - new Date(a.insertTime));

    const startIdx = page * size;
    const endIdx = Math.min(startIdx + size, totalElements);

    return {
        data: {
            content: allLogs.slice(startIdx, endIdx),
            page: { totalElements, totalPages: Math.ceil(totalElements / size), number: page, size }
        }
    };
};

// ===== 암복호화 로그 데모 데이터 =====
export const mockEncDecLog = (page = 0, size = 10) => {
    const now = new Date();
    const rng = seededRandom(hashStr('encDecLog' + now.toISOString().split('T')[0]));

    const policies = [
        { name: 'user_enc_policy', algo: 'AES', method: 'ENCRYPT' },
        { name: 'card_token_policy', algo: 'AES', method: 'DECRYPT' },
        { name: 'ssn_mask_policy', algo: 'ARIA', method: 'ENCRYPT' },
        { name: 'email_enc_policy', algo: 'AES', method: 'DECRYPT' },
        { name: 'phone_hash_policy', algo: 'SHA', method: 'HASH' },
        { name: 'backup_policy', algo: 'ARIA', method: 'ENCRYPT' },
        { name: 'api_session_policy', algo: 'AES', method: 'ENCRYPT' },
        { name: 'log_verify_policy', algo: 'SHA', method: 'HASH' },
    ];

    const totalElements = 243;
    const allLogs = [];

    for (let i = 0; i < totalElements; i++) {
        const minutesAgo = Math.floor(rng() * 60 * 24); // 오늘 하루 내 랜덤 시각
        const startDate = new Date(now.getTime() - minutesAgo * 60000);
        const durationMs = Math.floor(rng() * 500) + 10;
        const endDate = new Date(startDate.getTime() + durationMs);

        const policy = policies[Math.floor(rng() * policies.length)];
        const reqCount = Math.floor(rng() * 500) + 1;
        const failCount = rng() > 0.9 ? Math.floor(rng() * 5) + 1 : 0;
        const successCount = reqCount - failCount;

        allLogs.push({
            startTime: startDate.toISOString().replace('Z', ''),
            endTime: endDate.toISOString().replace('Z', ''),
            policyUuid: `demo-policy-${policy.name}`,
            policyName: policy.name,
            algo: policy.algo,
            cryptoMethod: policy.method,
            requestTotalCnt: reqCount,
            successCnt: successCount,
            failCnt: failCount
        });
    }

    allLogs.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

    const startIdx = page * size;
    const endIdx = Math.min(startIdx + size, totalElements);

    return {
        data: {
            content: allLogs.slice(startIdx, endIdx),
            page: { totalElements, totalPages: Math.ceil(totalElements / size), number: page, size }
        }
    };
};
